import React, { FC, ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
  actionsButtons?: boolean;
  /** Fixed column template, e.g. "1fr 1fr 2fr". Use this OR minColWidth. */
  columns?: string;
  /** Min column width for auto-fill wrapping, e.g. "160px". Ignores `columns` when set. */
  minColWidth?: string;
  gap?: number | string;
  rowGap?: number | string;
}

export const FilterBar: FC<Props> = ({
  children,
  className,
  actionsButtons,
  columns,
  minColWidth,
  gap = 12,
  rowGap,
}) => {
  const gridCols = minColWidth
    ? `repeat(auto-fill, minmax(${minColWidth}, 1fr))`
    : actionsButtons
      ? `${columns} auto`
      : columns;

  return (
    <div
      className={`w-full ${className ?? ""} items-start`}
      style={{
        display: "grid",
        gridTemplateColumns: gridCols,
        columnGap: typeof gap === "number" ? `${gap}px` : gap,
        rowGap: rowGap !== undefined
          ? (typeof rowGap === "number" ? `${rowGap}px` : rowGap)
          : (typeof gap === "number" ? `${gap}px` : gap),
        alignItems: "start",
      }}
    >
      {children}
      {actionsButtons && <div className="additionButtons" />}
    </div>
  );
};